// extracted by mini-css-extract-plugin
export var text = "VideoInformation-module--text--ijQ1J";
export var title = "VideoInformation-module--title--d0eXX";
export var wrapper = "VideoInformation-module--wrapper--GBtOC";